import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {questionnaireActions} from "_actions";
import {history} from '_helpers/history'
import StepTwo from "./steps/stepTwo";

import "./ceiba.scss";
import "./index.scss";

function QuestionnairePage(props) {
    const dispatch = useDispatch();
    const [answers, setAnswers] = useState(0);
    const [questions, setQuestions] = useState(-1);

    useEffect(() => {
        dispatch(questionnaireActions.getAssessmentsCode("CEIBA"))
        dispatch(questionnaireActions.getAnswers("CEIBA"))
    }, []);

    var assestmentsCodeData = useSelector((state) => state.questionnaireReducer.assestmentsCodeData);
    var answersData = useSelector((state) => state.questionnaireReducer.answersData);

    useEffect(() => {

        if (answersData){
            setAnswers(answersData.length);
        }
    },[answersData])


    useEffect(() => {

        if (assestmentsCodeData){
            setQuestions(assestmentsCodeData.length);
        }
    },[assestmentsCodeData])

    const goToCeiba = () => {
        if (questions === answers)
            history.push("/admin/end-ceiba")
        else
            history.push("/admin/ceiba")
    }

    const gotToXcelence = () => {
        history.push("/admin/xcelence")
    }

    return (
        <>
            <StepTwo
                answers={answers}
                questions={questions}
                goToCeiba={goToCeiba} gotToXcelence={gotToXcelence}/>
        </>
    )
}

export default withTranslation()(QuestionnairePage);
